import { render, staticRenderFns } from "./isteklilerceteklifedilenfiyatlar.vue?vue&type=template&id=6454ea5a&"
import script from "./isteklilerceteklifedilenfiyatlar.vue?vue&type=script&lang=js&"
export * from "./isteklilerceteklifedilenfiyatlar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports